// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2RiO3","input":"styles_input__1f0Vm"};